import { useEffect, useState } from "react";

const useScrolledPast = (offset) => {
  const [isPast, setIsPast] = useState(() => window.scrollY > offset);

  useEffect(() => {
    const handleScroll = () => setIsPast(window.scrollY > offset);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [offset]);

  return isPast;
};

export default useScrolledPast;
